import axios from 'axios'

export const HTTPWithoutAuth = axios.create({
  baseURL: import.meta.env.VITE_API_URL
})
